namespace $ {
	export function $shm_duckdb_sql_string( value: string ) {
		return "'" + String(value).replaceAll("'","''") + "'"
	}
}
